// extracted by mini-css-extract-plugin
module.exports = {"nav":"Navigation_nav__BXCkT","list":"Navigation_list__1Hd2H","desktop":"Navigation_desktop___uJG6","tablet":"Navigation_tablet__AKkom","mobile":"Navigation_mobile__ZogD_"};